import { render, staticRenderFns } from "./EnacCustomAtplAssessmentEditIndexStruct.vue?vue&type=template&id=1aef4b4b"
import script from "./EnacCustomAtplAssessmentEditIndexStruct.vue?vue&type=script&lang=js"
export * from "./EnacCustomAtplAssessmentEditIndexStruct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports